import Nullstack from 'nullstack';
export default function IconLayersDifference({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-layers-difference",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2"
  }), "   ", Nullstack.element("polyline", {
    points: "10 8 8 8 8 10"
  }), "   ", Nullstack.element("polyline", {
    points: "8 14 8 16 10 16"
  }), "   ", Nullstack.element("polyline", {
    points: "14 8 16 8 16 10"
  }), "   ", Nullstack.element("polyline", {
    points: "16 14 16 16 14 16"
  }), " ");
}